import { NgModule, APP_INITIALIZER, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { CoreModule } from './core/core.module';
import { AuthService } from './core/services/api/auth.service';
// Guards are now functional and don't need to be imported here
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { SiteContextInterceptor } from './core/interceptors/site-context.interceptor';

import { WINDOW_PROVIDERS } from './core/services/template/window.service';
import { RouterModule } from '@angular/router';
import { ToastrModule } from 'ngx-toastr';
import { BACKOFFICE_TOAST_CONFIG } from './layout/shared/feedback/backoffice-toast.config';
import { register } from 'swiper/element/bundle';
import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { AppSettingsService } from './core/services/app-settings.service';
import { FeatureFlagService } from './core/services/feature-flag.service';
import { NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { CustomDatepickerI18n } from './core/i18n/datepicker-i18n';
import { SharedModule } from './layout/shared/shared.module';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { environment } from 'src/environments/environment';

// register Swiper custom elements
register();





export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function initializeApp(appSettingsService: AppSettingsService) {
  return () => appSettingsService.initializeSettings();
}

export function initializeFeatureFlags(featureFlagService: FeatureFlagService) {
  return () => featureFlagService.initializeFlags();
}

export function localeIdFactory() {
  return 'en-US';
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    RouterModule,
    NgbModule,

    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireAuthModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    ToastrModule.forRoot(BACKOFFICE_TOAST_CONFIG),
    CoreModule,
    SharedModule
    
  ],
  providers: [
    AuthService,
    DragDropModule,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SiteContextInterceptor,
      multi: true
    },

    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppSettingsService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeFeatureFlags,
      deps: [FeatureFlagService],
      multi: true
    },
    {
      provide: LOCALE_ID,
      useFactory: localeIdFactory
    },
    {
      provide: NgbDatepickerI18n,
      useClass: CustomDatepickerI18n
    },
    WINDOW_PROVIDERS
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
